<template>
  <div itemtype="http://schema.org/Product" itemscope>
    <EmptyPage v-if="error || state.error" />

    <!-- Блок <div> нужен для избежания content-shifting -->
    <!-- Нужно заменить на скелетон -->
    <div v-else style="min-height: 100vh; overflow: hidden">
      <template v-if="state.product && state.currentSku">
        <meta itemprop="mpn" :content="`${state.product.id}`" />
        <meta itemprop="name" :content="state.product.title" />
        <meta itemprop="sku" :content="`${state.currentSku.id}`" />

        <Mobile v-if="isMobileOrTablet" :product="state.product as any" />
        <ProductDesktop v-else />
      </template>
    </div>

    <div id="desktop-fullscreen-slider"></div>
  </div>
</template>
<script setup lang="ts">
import { computed, onMounted, onUnmounted, watch } from 'vue';
import { useMedia } from '@mm-frontend/mm-web-ui-kit';
import Mobile from '../mobile/index.vue';
import ProductDesktop from '../desktop/ProductDesktop.vue';
import { useProductPage } from '../../business/use-product-page';
import EmptyPage from './EmptyPage.vue';

// PortalTarget removed - using Teleport with id instead

defineProps<{ error: any }>();

// Media breakpoints
const { isMobileOrTablet } = useMedia();

// Используем новый composable
const { state, onProductPageEnter, onProductPageLeave, selectSku } = useProductPage();

// TODO: Implement loader when available
const toggleLoader = (newLoading: boolean) => {
  if (newLoading) {
    console.log('TODO: Implement $loader.show()');
    // this.$loader.show();
  } else {
    console.log('TODO: Implement $loader.hide()');
    // this.$loader.hide();
  }
};

// Watchers
watch(
  () => state.loading,
  (newLoading) => toggleLoader(newLoading || false)
);

const router = useRouter();

// Lifecycle
onMounted(() => {
  onProductPageEnter();
  if (!state) return;
  selectSku(state?.currentSku.id, router, true);
});

// TODO: Implement headful when available
// headful setup would go here
console.log('TODO: Implement headful for SEO');
</script>
